module.exports = __webpack_public_path__ + "media/images/email/samsung_banner-32969f2bad3081a0deb83c684fe3d8e3.jpg";